/**
 * VSI.5 Stufe B (DEMO-SAFE-10) — rein frontendseitige Icon-Zuordnung für Hazard-Marker.
 *
 * Leitet AUSSCHLIESSLICH aus der vorhandenen Gefahren-Kategorie (Klartext) ein wiedererkennbares,
 * neutrales Icon ab. KEINE neuen Inhalte, keine Ableitung von Fachinformationen, keine Bewertung.
 * Fail-closed & ohne Raten: nur eindeutige Schlüsselbegriffe werden zugeordnet; fehlt/unbekannt ->
 * neutrales Warn-Icon (TriangleAlert). Gemeinsame Logik für Renderer und Plakat (Demo-Spiegelung,
 * KEIN Refactoring).
 */
import {
  TriangleAlert,
  ArrowDownToLine,
  Zap,
  Wrench,
  Flame,
  FlaskConical,
  Package,
  CloudRain,
} from "lucide-react";

// Reihenfolge = Prüfreihenfolge. Bewusst eng gehalten; "Umsturz" (enthält nur "sturz", nicht
// "absturz") matcht NICHT die Absturz-Regel -> fällt korrekt auf das neutrale Warn-Icon zurück.
const ICON_RULES = [
  { icon: ArrowDownToLine, keywords: ["absturz", "abstürz", "höhe", "hoehe", "herabfall", "herunterfall", "herabstürz"] },
  { icon: Zap, keywords: ["elektr", "strom", "spannung"] },
  { icon: Flame, keywords: ["brand", "feuer", "explos", "entzünd", "entzuend"] },
  { icon: FlaskConical, keywords: ["gefahrstoff", "chemi", "säure", "saeure", "lauge", "ätzend", "aetzend", "reizend", "gefahrgut", "toxisch", "gift"] },
  { icon: Package, keywords: ["ergonom", "heben", "tragen", "schwere last", "rücken", "ruecken"] },
  { icon: CloudRain, keywords: ["witterung", "wetter", "rutsch", "glätte", "glaette", "nässe", "naesse", "glatt"] },
  { icon: Wrench, keywords: ["mechan", "quetsch", "schnitt", "schneid", "klemm", "maschine", "werkzeug", "arbeitsmittel", "defekt", "scharfe kante"] },
];

export function getHazardIcon(category) {
  if (typeof category !== "string" || !category.trim()) return TriangleAlert;
  const c = category.toLowerCase();
  for (const rule of ICON_RULES) {
    if (rule.keywords.some((k) => c.includes(k))) return rule.icon;
  }
  return TriangleAlert; // fail-closed: neutrales Warn-Icon, kein Raten
}
